import { formatFileSize } from "@interface48/formatting";
import { Table, TableBodyRowButton } from "@interface48/tables";
import React, { useState } from "react";
import { DocumentDto } from "../../../api";

interface DocumentsTableProps {
  results?: DocumentDto[];
  width: number;
  height?: number;
  isLoading: boolean;
}

interface DocumentsTableState {
  sortDirection: "asc" | "desc";
  sortPropertyName: string;
}

export const DocumentsTableComponent = (props: DocumentsTableProps) => {
  const { results = [], width, height, isLoading } = props;
  const [tableState, setTableState] = useState<DocumentsTableState>({ sortDirection: "asc", sortPropertyName: "name" });

  const viewDetailsButtonRenderer = (id: string, row: DocumentDto) => (
    <TableBodyRowButton icon={["fas", "info"]} title="View Details" linkUrl={`/administration/documents/${row.id}`} />
  );

  const fileSizeRenderer = (fileSize: number, row: DocumentDto) => formatFileSize(fileSize);

  const fileSourceRenderer = (remoteFileUrl: string, row: DocumentDto) => (remoteFileUrl ? "Enablon" : "Local");

  const handleSortChange = (sortPropertyName: string, sortDirection: "asc" | "desc") => {
    setTableState({ sortDirection, sortPropertyName });
  };

  return (
    <Table
      columnSchemas={[
        {
          id: "id",
          width: 40,
          cellRenderer: viewDetailsButtonRenderer,
        },
        {
          id: "name",
          label: "Name",
        },
        { id: "mediaCategoryName", label: "Category", hidden: width < 900 },
        { id: "fileName", label: "File Name", hidden: width < 600 },
        { id: "fileExtension", label: "File Extension", hidden: width < 1200 },
        { id: "fileSizeBytes", label: "File Size", cellRenderer: fileSizeRenderer, hidden: width < 1300 },
        {
          id: "remoteFileUrl",
          label: "File Source",
          cellRenderer: fileSourceRenderer,
          hidden: width < 1400,
        },
        {
          id: "lastModifiedAt",
          label: "Last Modified",
          width: 140,
          format: { type: "date-time", options: { reference: "relative" } },
        },
      ]}
      data={results}
      dataSourceType="local"
      sorting={{
        sortDirection: tableState.sortDirection,
        sortPropertyName: tableState.sortPropertyName,
        onSortChange: handleSortChange,
      }}
      height={height}
      isLoading={isLoading}
    />
  );
};

export const DocumentsTable = DocumentsTableComponent;
